import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
// import { store } from "./app/store";
import reportWebVitals from "./reportWebVitals";

import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import reducer from "./features/redux/reducer";
// import { ReactQueryDevtools } from 'react-query/devtools'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

//REACT QUERY INCLUSIONS
import {
	QueryClient,
	QueryClientProvider,
} from 'react-query'
import { CoinProvider } from "./app/context/CoinProvider";

const queryClient = new QueryClient()

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}


const store = createStore(reducer, composeWithDevTools(applyMiddleware(thunk)))

// import ReactGA from "react-ga";
// import GlobalContextProvider from './app/context/context';

// ReactGA.initialize("UA-189640286-1");
// ReactGA.pageview(window.location.pathname + window.location.search);

ReactDOM.render(
	<React.StrictMode>
		<Router>
			<Provider store={store}>
				<QueryClientProvider client={queryClient}>
					<CoinProvider>
					<App />
					</CoinProvider>
					{/* <ReactQueryDevtools /> */}
				</QueryClientProvider>
			</Provider>
		</Router>
	</React.StrictMode>,
	document.getElementById("root")
);

serviceWorkerRegistration.register();
reportWebVitals();
